import { event, GtagEvent } from "./event";
export interface Search extends GtagEvent {
    search_term:string;
}
export const search = ($_:Search) => event('search',$_);